import React from "react";
import AppHeader from "@components/page/header/AppHeader";
import FooterInternal from "@components/page/footer/FooterInternal";
import { Box } from "@mui/material";

interface Props {
  title?: string;
  subtitle?: string;
  children: React.ReactElement;
}

const LoginPageContainer: React.FC<Props> = ({ title, subtitle, children }) => {
  return (
    <>
      <AppHeader title={title} subheadLeftSection={<>{subtitle}</>} />
      <Box
        width="40rem"
        marginX="auto"
        marginY={5}
        sx={{ flexShrink: 0, flexGrow: 1 }}
      >
        {children}
      </Box>
      <FooterInternal />
    </>
  );
};

export default LoginPageContainer;
